"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AddPaymentDialog = _interopRequireDefault(require("./AddPaymentDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PaymentDetails',
  components: {
    AddPaymentDialog: _AddPaymentDialog.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      detail: {
        merchantType: '',
        merchantName: '',
        periodStart: '',
        periodEnd: '',
        actualAmount: null
      },
      tableData: [{
        id: 1,
        operatorName: '张三',
        paymentDate: '2019-07-01 10:00:00',
        paymentAmount: 5,
        feishuApplyNo: 'FS20190701001',
        remark: '第一次打款'
      }, {
        id: 2,
        operatorName: '李四',
        paymentDate: '2019-07-15 14:30:00',
        paymentAmount: 5,
        feishuApplyNo: 'FS20190715002',
        remark: '第二次打款'
      }],
      pagination: {
        page: 1,
        total: 2
      }
    };
  },
  methods: {
    open: function open(row) {
      if (row) {
        this.detail.merchantType = row.merchantType || '';
        this.detail.merchantName = row.merchantName || '';
        this.detail.periodStart = row.periodStart || '';
        this.detail.periodEnd = row.periodEnd || '';
        this.detail.actualAmount = row.actualAmount;
      }
      this.dialogVisible = true;
    },
    openAddPaymentDialog: function openAddPaymentDialog() {
      this.$refs.addPaymentDialogRef.open(this.detail);
    }
  }
};